// Catalog of pages that a SuperAdmin can grant to an Admin.
// Keep in sync with the `routes` array in SideBar.jsx (admin menu).
// Used by AdminPermissions.jsx (permission picker) and SideBar.jsx (menu filter).
export const ADMIN_PAGES = [
  // Main
  { path: '/', label: 'Dashboard', group: 'Main' },
  { path: '/Realtime', label: 'Realtime', group: 'Main' },

  // Users
  { path: '/Users', label: 'Add User', group: 'Users' },
  { path: '/TeamLeaders', label: 'Permission', group: 'Users' },

  // Campaign
  { path: '/AddCampaign', label: 'Add Campaign', group: 'Campaign' },
  { path: '/Makegui', label: 'Make CRM', group: 'Campaign' },
  { path: '/Assignlist', label: 'Assign List', group: 'Campaign' },
  { path: '/Assignagent', label: 'Assign Agent', group: 'Campaign' },
  { path: '/CampDid', label: 'Camp DID', group: 'Campaign' },
  { path: '/AddDisposition', label: 'Disposition', group: 'Campaign' },
  { path: '/ChurnLeads', label: 'Churn Leads', group: 'Campaign' },
  { path: '/CampaignScript', label: 'Campaign Script', group: 'Campaign' },

  // Voice-Bot
  { path: '/VoiceBot', label: 'VoiceBot Campaign', group: 'Voice-Bot' },
  { path: '/VoiceBotKnowledgeBase', label: 'VoiceBot Knowledge Base', group: 'Voice-Bot' },
  { path: '/VoiceBotTools', label: 'VoiceBot Tools', group: 'Voice-Bot' },
  { path: '/VoiceBotCallLogs', label: 'VoiceBot Call Logs', group: 'Voice-Bot' },
  { path: '/VoiceBotConversions', label: 'VoiceBot Scheduled Visits', group: 'Voice-Bot' },
  { path: '/VoiceBotSettings', label: 'VoiceBot Settings', group: 'Voice-Bot' },
  { path: '/VoiceBotUploadNumber', label: 'VoiceBot Upload Number', group: 'Voice-Bot' },

  // Messaging
  { path: '/Messaging', label: 'Send Message', group: 'Messaging' },
  { path: '/MessagingSettings', label: 'Messaging Settings', group: 'Messaging' },

  // Reports
  { path: '/Reportlive', label: 'Live Report', group: 'Reports' },
  { path: '/Report', label: 'All Reports', group: 'Reports' },
  { path: '/FilterReport', label: 'Filter Report', group: 'Reports' },
  { path: '/FilterReportold', label: 'Filter Report (Old)', group: 'Reports' },
  { path: '/Agentlog', label: 'Agent Log', group: 'Reports' },
  { path: '/AgentPerformance', label: 'Agent Performance', group: 'Reports' },
  { path: '/BreakReport', label: 'Break Report', group: 'Reports' },
  { path: '/Callbackreport', label: 'Callback Report', group: 'Reports' },

  // Settings
  { path: '/UploadAudio', label: 'Upload Audio', group: 'Campaign' },
  { path: '/MusicOnHold', label: 'Music On Hold', group: 'Campaign' },
  { path: '/UploadNumber', label: 'Upload Number', group: 'Campaign' },
  { path: '/BlockNumber', label: 'Block Number', group: 'Settings' },
  { path: '/ChangePwd', label: 'Password Change', group: 'Settings' },
  { path: '/AllowIP', label: 'Allow IP', group: 'Settings' },
  { path: '/Break', label: 'Break Setting', group: 'Settings' },
  { path: '/TransferNumber', label: 'Transfer Number', group: 'Settings' },
  { path: '/ChannelSetting', label: 'Channel Setting', group: 'Settings' },

  // SMS Suits
  { path: '/Smssuits', label: 'SMS Suits', group: 'SMS' },
  { path: '/SmsportSetting', label: 'SMS Port Setting', group: 'SMS' },

  // IVR
  { path: '/AddAgent',      label: 'IVR Agent',  group: 'IVR' },
  { path: '/DrawIvr',       label: 'Draw IVR',   group: 'IVR' },
  { path: '/Group',         label: 'IVR Group',  group: 'IVR' },
  { path: '/IvrGroupAssignAgent', label: 'IVR Group — Assign Agent', group: 'IVR' },
  { path: '/IvrReport', label: 'IVR Report', group: 'IVR' },
  { path: '/IvrSmsReport',  label: 'SMS Report', group: 'IVR' },

  // Skills — top-level entry (Wave-1 Slice-B). 'Main' group keeps it flat
  // for the OBDADMIN sidebar instead of nesting under "Users". The
  // legacy /SupervisorSkills route still works as a redirect to
  // /Skills?tab=live but is no longer surfaced in any sidebar.
  { path: '/Skills', label: 'Skills', group: 'Main' },
];
